import { Directive, inject } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Works around a bug in digital-core's <adp-label> processLinks(): it checks
 * `target.href.indexOf('http') !== -1` to decide "is this an external link" —
 * but `target.href` is the resolved DOM property, always an absolute URL, so
 * that check is true for every link (internal or external) and the intended
 * SPA-navigation branch never runs. Every click on a CMS-authored link ends up
 * as a full browser page reload instead, which for an unguarded route like
 * /terms-and-conditions means the app re-bootstraps before plan data reloads
 * and gets stuck showing the unauthenticated fallback.
 *
 * Scoped to FAQ answer content only — nothing else in the app currently
 * renders real links through <adp-label>, so this is deliberately narrow
 * rather than a global override of digital-core's behavior.
 */
@Directive({
  selector: '[faqLinkFix]',
  standalone: true,
  host: {
    '(click)': 'onClick($event)',
  },
})
export class FaqLinkFixDirective {
  private router = inject(Router);

  onClick(event: MouseEvent): void {
    const target = event.target;
    if (!(target instanceof HTMLAnchorElement)) {
      return;
    }
    if (target.origin !== window.location.origin || target.protocol === 'mailto:' || target.protocol === 'tel:') {
      return;
    }
    event.preventDefault();
    this.router.navigateByUrl(target.pathname + target.search + target.hash);
  }
}
